import React, { ButtonHTMLAttributes } from "react";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { CustomButton } from "./CustomButton";

type ColorScheme = "blue" | "red" | "orange" | "green" | "gray";

interface ActionButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "title"> {
  title: React.ReactNode;
  colorScheme?: ColorScheme;
  isLoading?: boolean;
  tooltip?: string;
}

const colorClasses: Record<ColorScheme, string> = {
  blue: "text-blue-600 bg-gray-100 enabled:hover:bg-blue-100",
  red: "text-red-600 bg-gray-100 enabled:hover:bg-red-100",
  orange: "text-amber-600 bg-gray-100 enabled:hover:bg-amber-100",
  green: "text-green-600 bg-gray-100 enabled:hover:bg-green-100",
  gray: "text-gray-600 bg-gray-100 enabled:hover:bg-gray-200",
};

const ActionButton = React.forwardRef<HTMLButtonElement, ActionButtonProps>(
  (
    {
      title,
      colorScheme = "blue",
      isLoading = false,
      tooltip,
      className,
      disabled,
      type = "button",
      ...props
    },
    ref
  ) => {
    return (
      <CustomButton
        ref={ref}
        type={type}
        size="sm"
        variant="custom"
        disabled={disabled || isLoading}
        isLoading={isLoading}
        title={title}
        tooltip={tooltip}
        className={twMerge(
          clsx("shadow-none", colorClasses[colorScheme], className)
        )}
        {...(props as ButtonHTMLAttributes<HTMLButtonElement>)}
      />
    );
  }
);

ActionButton.displayName = "ActionButton";

export default ActionButton;
